import ReactGA from "react-ga";
import createHistory from "history/createBrowserHistory"

// method to initialize GA
export const initGA = (trackingID) => {           
   ReactGA.initialize(trackingID); 
}

//trigger the pageview method from ReactGa
export const PageView = () => { 
    ReactGA.pageview(window.location.pathname +  
                     window.location.hash); 
                     
}

//track any user actions like adding to cart or clicking on an image or button.
/**
 * Event - Add custom tracking event.
 * @param {string} category 
 * @param {string} action 
 * @param {string} label 
 */
export const Event = (category, action, label) => {
  ReactGA.event({
    category: category,
    action: action,
    label: label
  });
};

export const history = createHistory()
history.listen(location => {
	ReactGA.set({ page: location.pathname })
	ReactGA.pageview(location.pathname)
})


// WEBPACK FOOTER //
// ./src/modules/Tracking/index.js